import { render } from "./TrailerAssessment.vue?vue&type=template&id=26b728bc&scoped=true&ts=true"
import script from "./TrailerAssessment.vue?vue&type=script&lang=ts"
export * from "./TrailerAssessment.vue?vue&type=script&lang=ts"

import "./TrailerAssessment.vue?vue&type=style&index=0&id=26b728bc&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b728bc"]])

export default __exports__